import { useState } from "react";
import { X, Loader2, Download, ZoomIn, ZoomOut } from "lucide-react";

export default function PdfPreviewModal({ open, onClose, pdfUrl, loading }) {
  const [zoom, setZoom] = useState(100);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="pdf-preview-modal">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-4xl mx-4 h-[85vh] rounded-2xl overflow-hidden flex flex-col animate-fade-in-up"
        style={{ backgroundColor: 'var(--bg-card)', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 border-b" style={{ borderColor: 'var(--border-main)' }}>
          <h3 className="text-sm font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--text-primary)' }}>
            PDF Preview
          </h3>
          <div className="flex items-center gap-2">
            <button onClick={() => setZoom((z) => Math.max(50, z - 25))} className="p-1.5 rounded-lg transition-colors hover:bg-gray-100" title="Zoom out">
              <ZoomOut className="w-4 h-4" style={{ color: 'var(--text-secondary)' }} />
            </button>
            <span className="text-xs font-semibold w-10 text-center" style={{ fontFamily: 'IBM Plex Mono, monospace', color: 'var(--text-secondary)' }}>{zoom}%</span>
            <button onClick={() => setZoom((z) => Math.min(200, z + 25))} className="p-1.5 rounded-lg transition-colors hover:bg-gray-100" title="Zoom in">
              <ZoomIn className="w-4 h-4" style={{ color: 'var(--text-secondary)' }} />
            </button>
            {pdfUrl && (
              <a href={pdfUrl} download className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold text-white bg-[#00A3E0] hover:bg-[#0082B3] transition-colors">
                <Download className="w-3.5 h-3.5" /> Download
              </a>
            )}
            <button onClick={onClose} className="p-1.5 rounded-lg transition-colors hover:bg-gray-100" data-testid="pdf-preview-close">
              <X className="w-5 h-5" style={{ color: 'var(--text-secondary)' }} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-4" style={{ backgroundColor: '#525659' }}>
          {loading ? (
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <Loader2 className="w-8 h-8 text-white animate-spin mx-auto mb-3" />
                <p className="text-sm text-white/70">Generating preview...</p>
              </div>
            </div>
          ) : pdfUrl ? (
            <iframe
              src={pdfUrl}
              className="mx-auto rounded-lg shadow-lg bg-white"
              style={{ width: `${zoom}%`, height: '100%', minHeight: '500px', border: 'none' }}
              title="PDF Preview"
              data-testid="pdf-preview-iframe"
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <p className="text-sm text-white/50">No preview available</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
